import {
  AuthenticationEffects,
  InfluencersEffects,
  ProjectsEffects,
  UsersEffects,
  CampaignEffects,
  TemplateEffects,
  VariableEffects,
  TemplateSectionEffects,
  FileUploadEffects,
  ClientEffects,
  OrganizationEffects,
  MailVerifyEffects,
  ReportEffects,
  SegmentsEffects,
  SettingsEffects,
  RegistrationPlatformEffects,
  PackageEffect,
  TrackingTypeEffects,
  IndustriesEffects,
  LogsEffects,
  MailerDomainEffects,
  InfluencerSsoEffects,
  MailerServiceProviderEffects
} from '@app/stores';

export const appEffects = [AuthenticationEffects, ProjectsEffects, UsersEffects, InfluencersEffects, MailVerifyEffects,
  CampaignEffects, TemplateEffects, VariableEffects, TemplateSectionEffects, FileUploadEffects, ClientEffects, OrganizationEffects, ReportEffects,
  SegmentsEffects, SettingsEffects, RegistrationPlatformEffects, PackageEffect, TrackingTypeEffects, IndustriesEffects, LogsEffects, MailerDomainEffects, InfluencerSsoEffects, MailerServiceProviderEffects];
